<template>
    <item-selector v-model="val"
        v-bind="{ required, multiple, disabled, chips, outlined, rounded, dense, prependIcon, appendIcon, hint, label, singleLine, clearable, returnObject, rules, }"
        item-text="name" item-key="id" action="/resources/list">

        <template v-slot:selection="{ item }">{{ item?.name }} <v-chip v-if="item?.type" small>{{ item.type | resourceType
        }}</v-chip></template>
        <template v-slot:item="{ item }">{{ item?.name }} <v-chip  v-if="item?.type" small>{{ item.type | resourceType }}</v-chip>
        </template>
        <template v-if="showEmailLink" v-slot:append-outer>
            <v-btn icon v-if="value?.email" small :href="'mailto:' + value.email"
                color="primary"><v-icon>email</v-icon></v-btn>
        </template>
    </item-selector>
</template>

<script>
export default {
    props: {
        name: { required: false },
        value: { required: false },
        label: { type: String, default: '' },

        singleLine: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        outlined: {},
        rounded: {},
        dense: {},
        clearable: {},
        rules: {},


        multiple: { type: Boolean, default: false },
        chips: { type: Boolean, },
        showEmailLink: { type: Boolean, default: true },

        hint: { type: String, required: false },
        prependIcon: { type: String, },
        appendIcon: { type: String, },

        errors: {
            type: Array, default() {
                return []
            }
        },
        returnObject: { type: Boolean, default: true },
        debounce: { type: Number, default: 200 },
        preload: { type: Boolean, default: false },

        searchParam: { type: String, default: 's' },
        extraParams: { type: Object, default() { return {} } },
    },
    data() {
        return { val: this.value };
    },
    watch: {
        value(v) {
            if (this.val != v)
                this.val = v;
        },
        val(v) {
            if (this.value != v)
                this.$emit('input', v)
        }
    }
}
</script>

<style lang="scss" scoped></style>